export const FACEBOOK_PIXEL_ID_REGEXP = /^\d{15,16}$/
export const GOOGLE_ANALYTICS_ID_REGEXP = /^G-[A-Z0-9]{10}$/ // GA4 format example  G-A1B2CDE3FG
export const MAIL_RU_COUNTER_ID_REGEXP = /^\d{7,9}$/
export const VK_PIXEL_ID_REGEXP = /^VK-RTRG-\d+(-[A-Za-z]+)$/ // example VK-RTRG-123456-Abc
export const YANDEX_METRIKA_ID_REGEXP = /^\d{6,10}$/

export const analyticsIdsRegExps = {
  FACEBOOK_PIXEL_ID_REGEXP,
  GOOGLE_ANALYTICS_ID_REGEXP,
  MAIL_RU_COUNTER_ID_REGEXP,
  VK_PIXEL_ID_REGEXP,
  YANDEX_METRIKA_ID_REGEXP
}
